// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout-module--container--1OQpS","area":"Layout-module--area--1wLXW"};